<template lang="pug">
  .hair-color-bar-waitlist-form.container(:class="{ 'p-2': !newVersion, 'pl-20': newVersion, 'pt-10': newVersion, 'pr-20': newVersion, 'pb-10': newVersion }")
    .row.title-container(:class="{ 'text-center': !newVersion }")
      .xs-12
        p.f-secondary.upper.brand-color-1.xs-f-xxlarge.md-f-xxxlarge.max-at-tweak Nothing near you?

    .row(v-if="isInWaitlist || wasAddedToWaitlist")
      .xs-12
        .waitlist-thankyou.xs-12
          p.xs-f-medium.md-f-medium.lg-f-small.max-at-tweak(
            :class="{ 'text-center': !newVersion }"
          ) You have been added to the waitlist!

    .row(v-else)
      .xs-12(:class="{ 'mt-100m': !newVersion, 'mb-100m': !newVersion, 'mb-10': newVersion, 'mt-10': newVersion }")
        p.subtitle.s-f-small.md-f-medium.lg-f-small.max-at-tweak(
          :class="{ 'text-center': !newVersion }"
        ) Join our waitlist and we will let you know when a Hair Color Bar opens near you.

      .xs-12.sm-12.md-10(
        :class="{ 'lg-6': !newVersion, 'md-offset-1': !newVersion, 'lg-offset-3': !newVersion, 'lg-12': newVersion }"
      )
        form(@submit.prevent="onSubmit")
          MrEmailInput.email-input.xs-7.sm-8.md-5(
            v-model="email"
            :valid.sync="emailValid"
            :disabled="loading"
          )

          mr-input.zip-input.xs-5.sm-4.md-3(
            label="Zip Code"
            v-model="zip"
            :v="v$.zip"
            autocomplete="shipping postal-code"
            required dataMrAss="shipping-zip"
          )

          button.submit-button.mr-btn.btn-secondary.xs-font-xsmall.xs-12.md-4(
            type="submit"
            tabindex="0"
            aria-label="Submit"
            :class="{ disabled: loading }"
            :disabled="loading"
          ) {{ctaText}}
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex';
  import MrInput from '../../mrInput';
  import MrEmailInput from '../../MrEmailInput';
  import {useVuelidate} from "@vuelidate/core";

  const WAITLIST_TYPE = 'colorbar';

  export default {

    name: 'HairColorBarWaitlistForm',

    components: {
      MrEmailInput,
      MrInput,
    },

    props: {
      newVersion: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      email: null,
      emailValid: false,
      zip: null,
      loading: false,
      wasAddedToWaitlist: false,
    }),

    computed: {
      ...mapState('waitlist', [
        'waitlists',
      ]),

      ...mapGetters('addressBook', [
        'paymentEditAddressValidator',
      ]),

      ctaText() {
        if (this.loading) {
          if (this.newVersion) {
            return 'sending';
          }
          return 'adding to waitlist';
        } else {
          if (this.newVersion) {
            return 'send';
          }
          return 'join waitlist';
        }
      },

      isInWaitlist() {
        if (!this.waitlists) {
          return false;
        }
        return this.waitlists.some(({ waitlist_type }) => waitlist_type === WAITLIST_TYPE);
      },
    },

    created() {
      this.initWaitlists();
    },

    methods: {
      ...mapActions([
        'notifySuccess',
        'notifyError',
      ]),
      ...mapActions('waitlist', [
        'addToWaitlist',
        'initWaitlists',
      ]),

      onSubmit() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          return;
        }

        if (!this.emailValid) {
          return;
        }

        this.loading = true;
        this.addToWaitlist({
          email: this.email,
          zip: this.zip,
          waitlist_type: WAITLIST_TYPE,
        }).then(() => {
          this.loading = false;
          this.wasAddedToWaitlist = true;
          this.notifySuccess();
        }).catch(() => {
          this.loading = false;
          this.notifyError();
        });
      },
    },

    setup () {
      return {
        v$: useVuelidate()
      }
    },

    validations() {
      return {
        zip: this.paymentEditAddressValidator.post_code,
      };
    },
  };
</script>

<style lang="stylus">
  .hair-color-bar-waitlist-form
    background-color ui-color-3

    .zip-input
      margin 0px !important
      padding 0px 0.5em
  @media mq-mobile
    .hair-color-bar-waitlist-form
      .subtitle
        text-align left
      .email-input
        margin-bottom 1em
      .zip-input
        padding-right 0
        margin-bottom 1em

  @media mq-tablet
    .hair-color-bar-waitlist-form
      .subtitle
        text-align left
      .email-input
        margin-bottom 1em
      .zip-input
        padding-right 0
        margin-bottom 1em
</style>